import React from 'react';

import { MASK_CHAR, useBankDetailsFieldIntent, VALUE_CHAR } from '../AddBankDetails.helpers';

import { AddBankDetailsField } from './helpers/AddBankDetailsField';
import { useMaskField } from './helpers/AddBankDetailsHooks';

export const ACCOUNT_NUMBER_FIELD_NAME = 'accountNumber';
export const ACCOUNT_NUMBER_DEFAULT_FORMAT = VALUE_CHAR.repeat(8);
export const ACCOUNT_NUMBER_MASKED_FORMAT = `${MASK_CHAR.repeat(5)}${VALUE_CHAR.repeat(3)}`;

export const AccountNumber = () => {
  const { format, onInputFocus } = useMaskField(ACCOUNT_NUMBER_FIELD_NAME, {
    defaultFormat: ACCOUNT_NUMBER_DEFAULT_FORMAT,
    maskedFormat: ACCOUNT_NUMBER_MASKED_FORMAT,
  });

  const intent = useBankDetailsFieldIntent(ACCOUNT_NUMBER_FIELD_NAME);

  return (
    <div>
      <AddBankDetailsField
        {...{ intent, onInputFocus }}
        inputProps={{
          format,
        }}
        name={ACCOUNT_NUMBER_FIELD_NAME}
      />
    </div>
  );
};
